import React from "react";
import Brands from "../Brands/Brands";
import Hero from "../Hero/Hero";
import MobileApp from "../MobileApp/MobileApp";
import NewArival from "../NewArival/NewArival";
import Newsletter from "../Newsletter/Newsletter";
import Payback from "../Payback/Payback";

const Home = () => {
	return (
        <div className="home">
            <Hero></Hero>
            <Brands></Brands>
            <NewArival></NewArival>
            <Payback></Payback>
            <MobileApp></MobileApp>
            <Newsletter></Newsletter>
        </div>
	);
};

export default Home;
